export default class VideoShowMore {
  constructor(buttonSelector, elementSelector) {
    this.buttonSelector = buttonSelector;
    this.elementSelector = elementSelector;
    this.$element = {};
    this.options = {
      items: 0,
      offset: 0
    };
  }

  calculateWindow(offset) {
    var height = document.documentElement.clientHeight;
    var scrollTop = document.documentElement.scrollTop;

    return height + scrollTop + offset;
  }

  calculateOffset(element) {
    return element.offset().top;
  }

  displayItems() {
    this.$element = $(this.elementSelector).filter('.hide-me');

    if(this.options.items > 0){
      for(var i = 0; i < this.options.items; i++) {
        this.$element.eq(i).removeClass('hide-me');
      }
    } else {
      this.$element.removeClass('hide-me');
    }
  }

  getLastItem() {
    var element = $(this.elementSelector+".hide-me").eq(0);
    if(!element.length) return false;
    if(element.prev().length){
      return element.prev();
    } else {
      return element.parent();
    }
  }

  initButton(options) {
    this.options = $.extend(this.options, options);

    $(this.buttonSelector).on('click', function(e) {
      e.preventDefault();

      this.displayItems();
      if(!this.getLastItem()) $(this.buttonSelector).remove();
    }.bind(this));
  }

  initScroll(options) {
    var element;
    this.options = $.extend(this.options, options);

    window.addEventListener('scroll', function(){
      element = this.getLastItem();

      if(!element) return false;
      if(this.calculateWindow(this.options.offset) >= this.calculateOffset(element)){
        this.displayItems();
      }
    }.bind(this));
  }
}
